import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "data-name": "Layer 1",
  viewBox: "0 0 40.82 17.63"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "m37.56 5.7-3.31 2.88-.04.03 4.13 7.29c.15.26.11.6-.1.82l-.6.63-6.77-4.5 1.22-1.94-.29-.19-2.99 2.6c-3.27 2.84-6.95 4.48-9.6 4.28-1.07-.08-1.9-.45-2.46-1.11-1.56-1.81-.65-5.4 2.27-8.95l.34.23c-1.54 2.14-1.95 4.2-1.03 5.24.36.42.88.66 1.53.71 1.62.12 3.9-.94 6.11-2.85l.82-.73-10.17-6.76.64-.55c.45-.39 1.08-.52 1.65-.33l14.26 4.77.39-.34-.06-.04c-1.06-.71-2.05-2-1.73-3.17L34.2 1.6A6.6 6.6 0 0 1 36.71.24 6.4 6.4 0 0 1 39.04 0c.75.06 1.37.28 1.59.54.13.16.38.63-.07 1.62-.46 1-1.46 2.19-3 3.53ZM0 16.53h4.08V8.26c0-2.12 1.13-3.36 2.98-3.36s2.72 1.16 2.72 3.31v8.32h4.08V7.51c0-3.91-2.26-6.41-5.85-6.41-1.77 0-3.18.64-4.02 1.83V1.45H0v15.08Z",
      style: {"fill":"#e6222e"}
    }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "DY-logo"}) } }